module.exports = __webpack_public_path__ + "f4f89aea829f63d4b518959a4688adf9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/sales3.png
// module id = 545
// module chunks = 21 77 88